import { FORMAT_INCLUDE } from 'cyprus/enums';
import { FormatValue, FormatValueOptions } from 'cyprus/types';

import { formatCurrency } from './currency';
import { formatDate } from './date';
import { formatDuration } from './duration';
import { formatNumber } from './number';
import { formatPercent } from './percent';
import { formatRate } from './rate';
import { formatUnix } from './unix';

export const formatValue = (value: FormatValue, options: FormatValueOptions): string => {
  const format = String(options.format || '');
  const string = String(value || '');

  switch (true) {
    case format.includes(FORMAT_INCLUDE.NUMBER):
      return formatNumber(value, options);
    case format.includes(FORMAT_INCLUDE.CURRENCY):
      return formatCurrency(value, { decimal: 2, ...options });
    case format.includes(FORMAT_INCLUDE.PERCENT):
      return formatPercent(value, options);
    case format.includes(FORMAT_INCLUDE.RATE):
      return formatRate(value, options);
    case format.includes(FORMAT_INCLUDE.UNIX):
      return formatUnix(value, options);
    case format.includes(FORMAT_INCLUDE.DATE):
      return formatDate(value, options);
    case format.includes(FORMAT_INCLUDE.DURATION):
      return formatDuration(value, options);
    default:
      return string;
  }
};
